<template>
  <v-container fluid>
    <vue-headful title="User" description="Aimz"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">User {{ user.Email }}</h1>
        </div>
      </v-col>
    </v-row>
    <!--    <v-divider></v-divider>-->
    <!--    <p>Datenbankverbindung</p>-->
    <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
    <v-alert type="error" v-if="error">{{ reason }}</v-alert>

    <v-row>
      <v-col>
        <div class="mb-10">
          <p>Name: {{user.Name}}
            <v-btn v-if="!user.IsSuperUser && user.Email != username" class="accent ml-3" @click="gastLogin">Gastlogin</v-btn>
            <v-btn class="info ml-3" @click="recalcIndex">Recalc Index</v-btn>
          </p>
        </div>
        <p>Activated: {{!!user.IsActivated}}</p>
        <p>Initialized: {{!!user.IsInitialized}} <v-btn small @click="onInvertInitialized" class="mx-3">Invert</v-btn> ... user data form has been completed?</p>
        <p>
          Plan: {{user.Plan}}
          <v-btn-toggle class="ml-5" v-model="user.Plan" mandatory>
            <v-btn small text value="trial" @click="onChangePlan('trial')">Demo</v-btn>
            <v-btn small text value="paying" @click="onChangePlan('paying')">Kunde</v-btn>
            <v-btn small text value="blocked" @click="onChangePlan('blocked')">Gesperrt</v-btn>
            <v-btn small text value="test" @click="onChangePlan('test')">Test</v-btn>
          </v-btn-toggle>
        </p>
        <p>
          Product Category: {{user.Product}}
          <v-btn-toggle class="ml-5" v-model="user.Product" mandatory>
            <v-btn small text value="private user" @click="onChangeProductCategory('private user')">Privater</v-btn>
            <v-btn small text value="sales team" @click="onChangeProductCategory('sales team')">Vertriebler</v-btn>
          </v-btn-toggle>
        </p>
        <p>
          Product: (Id: {{user.ProductId}}, since: {{formatDatum(user.ProductDate)}})
          <v-btn-toggle class="ml-5" v-model="user.ProductId" mandatory>
            <v-btn small text :value="AboFree" @click="onChangeProduct(AboFree)">Free</v-btn>
            <v-btn small text :value="AboSilver" @click="onChangeProduct(AboSilver)">Silver</v-btn>
            <v-btn small text :value="AboGold" @click="onChangeProduct(AboGold)">Gold</v-btn>
          </v-btn-toggle>
        </p>


        <p>
          Group: {{user.Group}}
          <v-btn-toggle class="ml-5" v-model="user.Group" mandatory>
            <v-btn small text value="default" @click="onChangeGroup('default')">Default</v-btn>
            <v-btn small text value="team leader" @click="onChangeGroup('team leader')">Team Leader</v-btn>
            <v-btn small text value="director" @click="onChangeGroup('director')">Director</v-btn>
            <v-btn :disabled="!su" small text value="admin" @click="onChangeGroup('admin')">Admin</v-btn>
          </v-btn-toggle>
        </p>
        <p>CreationDate: {{formatDatum(user.CreationDate)}}</p>
        <p>LastLogin: {{formatDatum(user.LastLogin)}}</p>
        <p>LastLogout: {{formatDatum(user.LastLogout)}}</p>
        <p>Session: {{user.Session.Token}}</p>
        <p>Session created: {{formatDatum(user.Session.Created)}}</p>
        <p>LastActivity: {{formatDatum(user.Session.LastActivity)}}</p>
        <p>Super user: {{!!user.IsSuperUser}}
          <span v-if="user.IsSuperUser" @click="demote()" class="ml-3"><v-btn :disabled="!su">Demote to normal user</v-btn></span>
          <span v-else><v-btn :disabled="!su" class="red darken-4 white--text ml-3" @click="promote()">Promote to super user</v-btn></span>
        </p>
        <p><v-btn :disabled="!su" @click="delete_user()" class="red white--text">Delete user</v-btn></p>
<!--        team data-->
        <p>
          <v-icon class="mr-1">mdi-account-tie</v-icon>
          Director:
          <span v-if="user.DirectorEmail === user.Email" class="blue--text">Ich bin Director</span>
          <router-link v-else-if="user.DirectorEmail" :to="'/service/user/'+user.DirectorEmail">{{user.DirectorEmail}}</router-link>
        </p>
        <p>
          <v-icon class="mr-1">mdi-account-tie</v-icon>
          TeamLeader:
          <router-link v-if="user.TeamLeaderEmail" :to="'/service/user/'+user.TeamLeaderEmail">{{user.TeamLeaderEmail}}</router-link>
        </p>
        <p>
          <v-icon class="mr-1">mdi-account-multiple</v-icon>
          TeamMembers: {{JSON.stringify( user.MemberEmails)}}
        </p>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {formatDatum} from "@/reusable/date_and_time";
import UserLib from "@/components/UserLib";

export default {
  name: 'Service_User',
  components: {},
  data() {
    return {
      email: undefined,
      loading: false,
      reason: '',
      error: false,
      user: {
        Session: {},
        Plan: 'trial',
        Product: 'private user',
      }
    }
  },
  mounted() {
    this.onRouteChange();
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      var user=await this.$backend.get_user(this.email, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
      if (user)
        this.user=user;
    },
    onLoadSuccess(data) {
      this.loading = false;
      this.error = false;
      this.reason = "";
    },
    onLoadError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
    },
    onRouteChange() {
      this.email = this.$route.params.email;
      this.load();
    },
    async delete_user() {
      await this.$backend.delete_user(this.email);
      this.$router.replace("/service/users");
    },
    async demote() {
      this.user.IsSuperUser = false;
      this.user=await this.$backend.save_user(this.user);
    },
    async promote() {
      this.user.IsSuperUser = true;
      this.user=await this.$backend.save_user(this.user);
    },
    formatDatum(date) {
      return formatDatum(date);
    },
    onInvertInitialized() {
      this.user.IsInitialized=!this.user.IsInitialized;
      this.$backend.save_user(this.user);
    },
    async gastLogin() {
      this.loading = true;
      var data=await this.$backend.gast_login(this.email);
      this.loading = false;
      if (!data) {
        this.$events.$emit("error", "Gast-Login failed, got no data.")
        return;
      }
      this.$app.onLogin(data.token, data.user, data.guest, data.guest_user);
      this.error = false;
      this.$router.go(-1000);
      this.$router.replace('/lobby')
      this.$events.$emit("update_streak");
    },
    async recalcIndex() {
      this.loading = true;
      var isoDate=new Date(Date.now()).toISOString().substring(0,10);
      var calculation=await this.$backend.recalc_index(this.email, isoDate);
      console.log(`Recalc index for ${this.email} date: ${isoDate}:`, calculation);
      this.loading = false;
    },
    async onChangePlan(plan) {
      this.$set(this.user, 'Plan', plan);
      this.user=await this.$backend.save_user(this.user);
    },
    async onChangeProductCategory(product) {
      this.$set(this.user, 'Product', product);
      this.user=await this.$backend.save_user(this.user);
    },
    async onChangeProduct(productID) {
      this.$set(this.user, 'ProductId', productID);
      this.user=await this.$backend.save_user(this.user);
    },
    async onChangeGroup(group) {
      this.$set(this.user, 'Group', group);
      this.user=await this.$backend.save_user(this.user);
    },
  },
  computed: {
    username() { return this.$app.username; },
    su() { return this.$app.is_super_user; },
    AboFree() {return UserLib.AboFree;},
    AboSilver() {return UserLib.AboSilver;},
    AboGold() {return UserLib.AboGold;},
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      // console.log("$route(to, from)")
      this.onRouteChange();
    }
  }
}
</script>
